import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e9e580b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box1"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"box1_1\" data-v-e9e580b8><img class=\"box1_1_logo\" src=\"https://apply.y-sjf.com/logob.png\" alt=\"\" data-v-e9e580b8><div class=\"box_w\" data-v-e9e580b8><div class=\"wz\" data-v-e9e580b8><p data-v-e9e580b8>独一无二的新经济模型</p><p data-v-e9e580b8>线上线下融合发展消费循环互通</p><p data-v-e9e580b8>运用新模式，促进新消费，发展新经济从而形成新业态</p><br data-v-e9e580b8><br data-v-e9e580b8><p class=\"ms\" data-v-e9e580b8>-- 聚合式消费增值创业服务平台 --</p></div><img class=\"box1_1_bg\" src=\"https://apply.y-sjf.com/bg.png\" alt=\"\" data-v-e9e580b8></div></div>", 1);
const _hoisted_3 = {
  class: "box1_2"
};
const _hoisted_4 = {
  class: "box1_3"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, " 登录 ", -1));
const _hoisted_6 = {
  class: "ids"
};
const _hoisted_7 = {
  key: 0,
  class: "erweima"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "saoname"
}, "请使用APP扫码登录", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "saoname"
}, [/*#__PURE__*/_createTextVNode("扫码即代表同意"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://apply.y-sjf.com/reg/useragreement.html"
}, "《用户协议》"), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://apply.y-sjf.com/reg/privacy.html"
}, "《隐私政策》")], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://apply.y-sjf.com/reg/useragreement.html"
}, "《用户协议》", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://apply.y-sjf.com/reg/privacy.html"
}, "《隐私政策》", -1));
import { ajax } from '@/api/ajax.js';
import { ref, reactive } from "vue";
import { useRouter } from 'vue-router';
import { writeXLSX } from 'xlsx';
export default {
  __name: 'index',
  setup(__props) {
    const checked = ref(null);
    const token = ref(null);
    const img = ref(null);
    const router = useRouter();
    const timeCount = ref(60);
    const isSendCode = ref(false);
    const loginForm = reactive({
      data: {
        phone: "",
        password: "",
        code: '',
        type: 1,
        xy: false
      }
    });
    const typez = id => {
      loginForm.data.type = id;
    };
    const getwebsocket = () => {
      const ws = new WebSocket("wss://www.y-sjf.com/ws?type=login");
      //连接websocket
      ws.onopen = function () {

        // ws.send("发送数据")
      };
      // //
      ws.onmessage = function (evt) {
        var received_msg = evt.data;
        var msg = JSON.parse(received_msg);
        if (msg.type == "login") {
          img.value = msg.url;
        }
        if (msg.type == "login_token") {
          localStorage.setItem("token", msg.token);
          router.push('/');
        }

        // console.log(msg)
      };
    };

    getwebsocket();

    //表单验证
    // const rules = ref({
    //   phone: [
    //     {
    //       required: true,
    //       message: "不能为空",
    //       trigger: "blur"
    //     }
    //   ],
    //   password: [
    //     {
    //       required: true,
    //       message: "不能为空",
    //       trigger: "blur"
    //     }
    //   ],
    //   xy: [
    //     {
    //       required: true,
    //       message: "不能为空",
    //       trigger: "blur"
    //     }
    //   ],

    // })

    const formRef = ref(null);
    //登录
    const login = () => {
      //关闭websocket

      let phone = loginForm.data.phone;
      let xy = loginForm.data.xy;
      let code = loginForm.data.code;
      let password = loginForm.data.password;
      if (!phone) {
        ElMessage({
          type: 'error',
          message: "手机号不能为空"
        });
        return false;
      }
      if (!xy) {
        ElMessage({
          type: 'error',
          message: "请勾选协议"
        });
        return false;
      }
      if (loginForm.data.type == 2) {
        if (!code) {
          ElMessage({
            type: 'error',
            message: "验证码不能为空"
          });
          return false;
        }
        ajax("Public_fun/login_codes", data => {
          localStorage.setItem("token", data.data.token);
          router.push('/');
          ElMessage({
            type: 'success',
            message: "登陆成功"
          });
          // wx.close();
        }, error => {
          ElMessage({
            type: 'error',
            message: error.msg
          });
        }, {
          phone: loginForm.data.phone,
          code: loginForm.data.code
        });
      } else {
        if (!password) {
          ElMessage({
            type: 'error',
            message: "密码不能为空"
          });
          return false;
        }
        ajax("Public_fun/login_password", data => {
          localStorage.setItem("token", data.data.token);
          router.push('/');
          // wx.close();
        }, error => {
          ElMessage({
            type: 'error',
            message: error.msg
          });
        }, {
          phone: loginForm.data.phone,
          password: loginForm.data.password
        });
      }
    };
    const sendcode = () => {
      let phone = loginForm.data.phone;
      ajax("Public_fun/login_code", data => {
        isSendCode.value = true;
        let timmer = setInterval(() => {
          timeCount.value--;
          if (timeCount.value <= 0) {
            timeCount.value = 60;
            isSendCode.value = false;
            clearInterval(timmer);
          }
        }, 1000);
        ElMessage({
          type: 'success',
          message: data.msg
        });
      }, error => {
        ElMessage({
          type: 'error',
          message: error.msg
        });
      }, {
        phone: phone
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: _normalizeClass(loginForm.data.type == 1 ? 'fs lv' : 'fs'),
        onClick: _cache[0] || (_cache[0] = $event => typez(1))
      }, "账号密码登录", 2), _createElementVNode("div", {
        class: _normalizeClass(loginForm.data.type == 2 ? 'fs lv' : 'fs'),
        onClick: _cache[1] || (_cache[1] = $event => typez(2))
      }, "验证码登录", 2), _createElementVNode("div", {
        class: _normalizeClass(loginForm.data.type == 3 ? 'fs lv' : 'fs'),
        onClick: _cache[2] || (_cache[2] = $event => typez(3))
      }, "APP扫码登录", 2)]), _createVNode(_component_el_form, {
        style: {
          "position": "relative"
        },
        rules: _ctx.rules,
        ref: "loginForm.data",
        model: loginForm.data,
        class: "loginContainer"
      }, {
        default: _withCtx(() => [loginForm.data.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
          class: "erw",
          src: img.value,
          alt: ""
        }, null, 8, _hoisted_8), _hoisted_9, _hoisted_10])) : _createCommentVNode("", true), loginForm.data.type != 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          prop: "phone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "text",
            modelValue: loginForm.data.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => loginForm.data.phone = $event),
            placeholder: "手机"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), loginForm.data.type == 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "password",
            modelValue: loginForm.data.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => loginForm.data.password = $event),
            placeholder: "请输入密码"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), loginForm.data.type == 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 3,
          style: {
            "width": "50%"
          },
          prop: "code"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "code",
            modelValue: loginForm.data.code,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => loginForm.data.code = $event),
            placeholder: "请输入验证码"
          }, null, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), loginForm.data.type == 2 && !isSendCode.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 4,
          class: "btns",
          type: "primary",
          style: {
            "width": "40%",
            "margin-left": "180px"
          },
          onClick: sendcode
        }, {
          default: _withCtx(() => [_createTextVNode("发送验证码")]),
          _: 1
        })) : _createCommentVNode("", true), loginForm.data.type == 2 && isSendCode.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 5,
          class: "btns",
          type: "primary",
          style: {
            "width": "40%",
            "margin-left": "180px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode("重新发送 " + _toDisplayString(timeCount.value), 1)]),
          _: 1
        })) : _createCommentVNode("", true), loginForm.data.type != 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 6,
          prop: "xy"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            modelValue: loginForm.data.xy,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => loginForm.data.xy = $event),
            "text-color": "#38c8a0",
            fill: "#38c8a0",
            class: "loginRemember"
          }, {
            default: _withCtx(() => [_hoisted_11, _createTextVNode(" 和 "), _hoisted_12]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), loginForm.data.type != 3 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 7,
          type: "primary",
          style: {
            "width": "100%"
          },
          onClick: login
        }, {
          default: _withCtx(() => [_createTextVNode("登录")]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["rules", "model"])])])]);
    };
  }
};